import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Box,
  styled,
  Table,
  TableBody,
  TableRow,
  TableCell,
  useTheme,
  Typography,
  IconButton,
  TableHead,
} from "@mui/material";

import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { formatValue, HtmlTooltip } from "../../component/Methods";
import { formatTimeAgo } from "../../utils/helpers";
import BenchmarkPopUp from "./Popup/BenchmarkPopUp";

const Tablecell = styled(TableCell)(({ theme }) => ({
  fontSize: "12px",
  padding: "1px 2px 1px 5px",
}));

const BenchMarkTable = ({ marketData }) => {

  const [benchmarksWithMarketData, setBenchmarksWithMarketData] = useState([]);
  const [isGridViewBenchmark, setIsGridViewBenchmark] = useState(false);
  

  useEffect(() => {
    const benchmarks = [
      { name: "NASDAQ",  symbol2: "qqq" },
      { name: "S&P 500",  symbol2: "spy" },
      { name: "RUSSELL 2000",  symbol2: "iwm" },
      { name: "DOW JONES",  symbol2: "dia" },
      { name: "RUSSELL 3000", symbol2: "iyk" },
    ];

    const updated = benchmarks.map((benchmark) => {
   
      const matchingData2 = marketData?.find(
        (data) => data?.symbol === benchmark.symbol2
      );
      const toReturn = {
        name: benchmark.name,
        symbol2: benchmark.symbol2,
        val2: 0,
        date2: "N/A",
      };
     
      if (matchingData2) {
        const { price, yestPrice, expiration } = matchingData2;
        const chPer = (((price - yestPrice) / yestPrice) * 100).toFixed(2);
        toReturn.val2 = chPer;
        toReturn.date2 = expiration;
      }
      return toReturn;
    });
    setBenchmarksWithMarketData(updated);
  }, [marketData]);
  const toggleGridViewBenchmark = () => {
    setIsGridViewBenchmark(!isGridViewBenchmark);
  };

  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          border: `1px solid ${theme.palette.lightGrey.tableHeader}`,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: theme.palette.lightGrey.tableHeader,
            px: 1,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ color: theme.palette.lightGrey.textColor }}
          >
            Benchmark Intraday Performance
          </Typography>
        
        </Box>
        <Table size="small">
         

          <TableBody>
            {benchmarksWithMarketData.map((row) => (
              <TableRow
                key={row.name}
                sx={{
                  "&:hover": {
                    background: theme.palette.grey[200],
                    cursor: "pointer",
                  },
                }}
              >
                <Tablecell
                  colSpan={2}
                  align="left"
                  onClick={() => {
                    //   handleBenchMark(row);
                  }}
                  sx={{
                    color: theme.palette.lightGrey.textColor,
                    fontSize: theme.typography.bodyText12.fontSize,
                    fontWeight: theme.typography.bodyText12.fontWeight,
                    borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                  }}
                >
                  {row?.name}
                </Tablecell>


                <Tablecell
                  align="left"
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  {row.symbol2}
                </Tablecell>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit" sx={{ fontSize: "12px" }}>
                        Market:<b> Primary </b>
                      </Typography>

                      <Typography color="inherit" sx={{ fontSize: "12px" }}>
                        Updated: <b>{formatTimeAgo(row?.date2).msg}</b>
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <Tablecell
                    align="right"
                    style={{
                      color: row.val2 >= 0 
                        ? (theme.palette.mode === 'dark' ? "#4ade80" : "#16a34a") 
                        : (theme.palette.mode === 'dark' ? "#f87171" : "#dc2626"),
                    }}
                  >
                    {row.val2 >= 0 ? (
                      <>{row.val2}%&nbsp;</>
                    ) : (
                      `(${row.val2 * -1}%)`
                    )}
                  </Tablecell>
                </HtmlTooltip>
              </TableRow> 
            ))}
          </TableBody>
        </Table>
      </Box>
     
    </>
  );
};
// Memoize the component to prevent unnecessary re-renders
export default React.memo(BenchMarkTable);
